import { openModal } from '@core/components/ModalStack';
import { StripeFormModalProps } from './StripeFormModal';

export async function openStripeFormModal(props: StripeFormModalProps) {
  const { StripeFormModal } = await import('./StripeFormModal');

  openModal(StripeFormModal, props);
}
